export const expenseCategories = [
    'Food',
    'Transportation',
    'Housing',
    'Entertainment',
    'Health',
    'Education',
    'Clothing',
    'Gifts and Donations',
    'Travel',
    'Other Expenses',
];

export const incomeCategories = [
    'Salary',
    'Freelance',
    'Interest and Dividends',
    'Gifts',
    'Sales',
    'Other Income',
];

export const allCategories = [...expenseCategories, ...incomeCategories];
